<template>
  <Card class="menu-card">
    <el-menu slot="title" :default-active="activeIndex" mode="horizontal" @select="handleSelect">
      <el-menu-item index="1">随访人员统计</el-menu-item>
      <el-menu-item index="2">随访详情统计</el-menu-item>
    </el-menu>
    <div slot="content">
      <FollowupPersonnel v-if="menuIndex == 1" />
      <FollowupDetails v-if="menuIndex == 2" />
    </div>
  </Card>
</template>

<script lang="js">
import FollowupPersonnel from "./FollowupPersonnel.vue"; // 随访人员
import FollowupDetails from "./FollowupDetails.vue"; // 随访详情
export default {
  name: "FollowUp",
  components: { FollowupPersonnel, FollowupDetails },
  data() {
    return {
      activeIndex: "1", // 默认激活菜单
      menuIndex: "1", // 菜单索引
    }
  },
  created() {
    let index = this.$session.get('followUpIndex')
    if (index) this.activeIndex = this.menuIndex = index;
  },
  methods:{
    // 切换当前显示组件
    handleSelect(key) {
      this.menuIndex = key;
      this.$session.set('followUpIndex', key);
    }
  }
};
</script>